import type { PartialVehicleData as VehicleData } from "shared/dist/types/vehicleData";

import { IMAGES_SERVER } from "@/config/settings";

export const CAIA_LOGO_URL = `${IMAGES_SERVER}/v2/items/Logo_50ans_PS.png`;

export const iframeSlidesLogin = [
    "https://www.points.fr/",
    "https://www.points.fr/",
];
export const iframeSlides = [
    "https://www.points.fr/",
    "https://www.points.fr/",
    "https://www.points.fr/",
    "https://www.points.fr/",
    "https://www.points.fr/",
    "https://www.points.fr/",
    "https://www.points.fr/",
];
export const iframeSlidesCaridentifier = [
    {
        title: "LiveC@r",
        img: `${IMAGES_SERVER}/v2/carH/hub_icon.png`,
        makeURL: (vd: VehicleData): string =>
            `https://call.ncc.mx/join/${vd.Codif_Vin_PRF}`,
    },
];
